module.exports = function($) {

  var hiddenClass = 'hidden';
  var disabledClass = 'sw--disabled';

  $.fn.swHide = function() {
    $(this).addClass(hiddenClass);

    return this;
  };

  $.fn.swShow = function() {
    $(this).removeClass(hiddenClass);

    return this;
  };

  $.fn.swIsShown = function() {
    return !$(this).hasClass(hiddenClass);
  };

  $.fn.swToggleVisibility = function() {
    $(this).toggleClass(hiddenClass);

    return this;
  };

  $.fn.swDisable = function() {
    return $(this).addClass(disabledClass);
  };

  $.fn.swEnable = function() {
    return $(this).removeClass(disabledClass);
  };

  $.fn.swIsDisabled = function() {
    return $(this).hasClass(disabledClass);
  };

};
